import { useEffect } from 'react';
import { usePlaidLink } from 'react-plaid-link';

// Headless Plaid Link launcher. Rendered only while a link token exists; it
// opens Plaid Link as soon as the SDK is ready, then reports back:
//   - onSuccess(publicToken, metadata) — user finished linking a bank
//   - onExit(err) — user closed Link (or it errored) without finishing
// The parent clears the token in both callbacks so this unmounts.
export default function PlaidLink({ token, onSuccess, onExit }) {
  const { open, ready } = usePlaidLink({
    token,
    onSuccess: (publicToken, metadata) => onSuccess(publicToken, metadata),
    onExit: (err) => onExit && onExit(err),
  });

  useEffect(() => {
    if (ready) open();
  }, [ready, open]);

  return null;
}
